const BASE_URL = 'https://goldregen-muenchen.de'

export function setPageTitleMiddleware (to, from, next) {
  const pageTitle = to.matched.find(item => item.meta.title)

  if (pageTitle) {
    window.document.title = pageTitle.meta.title

    const description = to.matched.find(item => item.meta.description)
    if (description) {
      const metaDesc = document.querySelector('meta[name="description"]')
      if (metaDesc) {
        metaDesc.setAttribute('content', description.meta.description)
      }
      const ogDesc = document.querySelector('meta[property="og:description"]')
      if (ogDesc) {
        ogDesc.setAttribute('content', description.meta.description)
      }
      const ogTitle = document.querySelector('meta[property="og:title"]')
      if (ogTitle) {
        ogTitle.setAttribute('content', pageTitle.meta.title)
      }
    }
  }

  // Update canonical URL
  const canonicalUrl = BASE_URL + (to.path === '/' ? '/' : to.path + '/')
  let canonical = document.querySelector('link[rel="canonical"]')
  if (!canonical) {
    canonical = document.createElement('link')
    canonical.setAttribute('rel', 'canonical')
    document.head.appendChild(canonical)
  }
  canonical.setAttribute('href', canonicalUrl)

  // Update hreflang
  let hreflang = document.querySelector('link[hreflang="de"]')
  if (!hreflang) {
    hreflang = document.createElement('link')
    hreflang.setAttribute('rel', 'alternate')
    hreflang.setAttribute('hreflang', 'de')
    document.head.appendChild(hreflang)
  }
  hreflang.setAttribute('href', canonicalUrl)

  // Update og:url
  const ogUrl = document.querySelector('meta[property="og:url"]')
  if (ogUrl) {
    ogUrl.setAttribute('content', canonicalUrl)
  }

  next()
}

// Routes that use fullpage.js — these need overflow:hidden
const FULLPAGE_ROUTES = ['/', '/impressum']

export function resetScrollMiddleware (to) {
  if (!FULLPAGE_ROUTES.includes(to.path)) {
    // Force normal scrolling on non-fullpage pages
    document.documentElement.classList.remove('fp-enabled')
    document.documentElement.classList.add('scroll-enabled')
    document.documentElement.style.overflow = ''
    document.documentElement.style.height = ''
    document.body.style.overflow = ''
    document.body.style.height = ''
  } else {
    document.documentElement.classList.remove('scroll-enabled')
  }
}
